export default __webpack_public_path__ + "static/media/ellipsis.bdbd07e1.svg";